var app = require('../index');

app.fn('login.login', function(e, el) {
	//TEMP COMMENTED
	//UNCOMMENT WHEN DONE TROUBLESHOOTING X-BIND ISSUE WITH LOGIN FORM
	//
	//e.preventDefault();
	var model = app.model;

	//TODO figure out a less hacky way to temporarily store the user's email address
    //in case of login failure.
    //(Maybe an AJAX login form)
	jQuery.post('save-login-email-to-session', {email: model.get('_session.loginEmail') })
		.done(submitLoginForm)
		.error(submitLoginForm); //it's not critical that we re-display the email
});

function submitLoginForm() {
	$('#login-form')[0].submit();
}

app.fn('login.showForgotPasswordForm', function(e, el) {
	this.model.set('_page.showForgotPasswordForm', true);
});